import {Green4, Grey17, Grey6, Red3} from "../../theme/styles";

import {EnlilTable} from "../EnlilTable";
import withNavigate from "../../util/useNavigate";
import withBreakpoint from "../../util/withBreakpoint";
import EventBus from "../../util/EventBus";
import {Chip, IconButton, Menu, MenuItem, Typography} from "@mui/material";
import {Edit, MoreVert} from "@mui/icons-material";
import css_self from "../Navigation/css/NavBar.module.scss";
import React from "react";
import BillSubscriptionFormApplet from "../../eoec/applet/impl/BillConfiguration/BillSubscriptionFormApplet";
import CCAlertDialog from "../Common/CCAlertDialog";
import {withAppContext} from "../../util/withAppContext";

class BillSubscriptionTable extends EnlilTable {

    componentDidMount() {
        super.componentDidMount();

        EventBus.components.addListener("bill-subscription-form-applet-cancel", this.onCancelHandler);
        EventBus.components.addListener("bill-subscription-form-applet-save", this.onCancelHandler);
        EventBus.error.addListener("bill-subscription-error", this.onBillSubscriptionError);
    }

    componentWillUnmount() {
        super.componentWillUnmount();

        EventBus.components.removeListener("bill-subscription-form-applet-cancel", this.onCancelHandler);
        EventBus.components.removeListener("bill-subscription-form-applet-save", this.onCancelHandler);
        EventBus.error.removeListener("bill-subscription-error", this.onBillSubscriptionError);
    }

    enterpriseComponentInsertCompleted(ec) {
        super.enterpriseComponentInsertCompleted(ec)

        ec.invalidateChildren();
    }

    enterpriseComponentDeleteCompleted(ec) {
        super.enterpriseComponentDeleteCompleted(ec)

        ec.invalidateChildren();
    }

    getCellRenderer(name) {
        if (name === "Action Cell") {
            return this.renderActionCell;
        } else if (name === "Subscription Status Cell") {
            return this.renderStatusCell;
        } else if (name === "Event Type and Version Cell") {
            return this.renderEventTypeVersionCell;
        }
        return super.getCellRenderer(name);
    };

    handleMenuClick(identifier) {
        if (identifier === "New Event") {
            this.setState({renderTarget: "New Event"});
        }
        super.handleMenuClick(identifier);
    }

    renderExtension() {
        if (this.state.renderTarget === "Edit Subscription") {
            return <BillSubscriptionFormApplet enterpriseComponent={this.applet.getEnterpriseComponent()} defaultAction="Edit" />;
        }
        if (this.state.renderTarget === "Bill Subscription Error") {
            return <CCAlertDialog message={this.state.renderMessage} link={this.state.renderLink}/>;
        }
    };

    onCancelHandler = () => {
        this.setState({renderTarget: null});
    };

    onBillSubscriptionError = (args) => {
        let message = "";
        let link = "";
        if (args[0] === "CC-DKIE-09ID") {
            message = "An error has occurred! Please refer to the link below."
            link = args[1];
        }
        this.setState({renderTarget: "Bill Subscription Error", renderMessage: message, renderLink: link});
    };

    renderStatusCell = (___, params, __, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        let backgroundColor;

        let statusValue;
        if (this.state.buffer[params.row.id].get("Status") === false) {
            backgroundColor = Red3;
            statusValue = "Not Enabled"
        } else {
            backgroundColor = Green4;
            statusValue = "Enabled"
        }
        return (
            <div style={{marginTop: "-2px"}}>
                <Chip label={statusValue} size="small" style={{fontSize: 12, backgroundColor: backgroundColor, color: "#FFFFFF", marginTop: 1}} />
            </div>
        );
    };

    renderEventTypeVersionCell = (___, params, __, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        return (
            <div style={{marginTop: "-2px"}}>
                {this.state.buffer[params.row.id].get("EventType")}/{this.state.buffer[params.row.id].get("EventVersion")}
            </div>
        );
    };

    renderActionCell = (___, params, columnId, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        return (
            <div style={{width: "50px", marginTop: "-4px", backgroundColor: "#FFFFFF", marginLeft: "-10px", marginRight: "-20px", paddingBottom: "5px", paddingLeft: "4px"}}>
                <IconButton onClick={(event) => {
                    if (this.state.tableActionMenuTarget === null) {
                        this.setState({tableActionMenuTarget: event.currentTarget});
                    } else {
                        this.setState({tableActionMenuTarget: null});
                    }
                }}>
                    <MoreVert />
                </IconButton>
                <Menu anchorEl={this.state.tableActionMenuTarget}
                      anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                      transformOrigin={{vertical: -10, horizontal: "center"}}
                      open={this.state.tableActionMenuTarget !== null && this.state.tableActionMenuTarget !== undefined}
                      onClose={() => this.setState({tableActionMenuTarget: null})}
                      TransitionProps={{
                          onExited: () => this.setState({tableActionMenuTarget: null}),
                      }}
                      MenuListProps={{
                          ...{"data-cc-component": "NavMenu"},
                          disablePadding: true,
                          style: {"minWidth": "200px"},
                      }}
                      PaperProps={{
                          elevation: 2,
                      }}
                >
                    <MenuItem divider key={"1"} className={css_self.Standard} onClick={() => {
                        this.setState({tableActionMenuTarget: null, renderTarget: "Edit Subscription"});
                    }}>
                        <Edit style={{color: Grey6}} />
                        <Typography style={{fontSize: "15px", fontWeight: "400", color: Grey17}}>Edit Subscription</Typography>
                    </MenuItem>
                </Menu>
            </div>
        )
    }
}

export default withNavigate(withAppContext(withBreakpoint(BillSubscriptionTable)));